<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Separation Reason"
      text="Edit Separation Reason"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="localSeparationReason.reason"
                v-validate="'required'"
                label="Reason"
                outlined
                :error-messages="errors.collect('reason')"
                data-vv-name="reason"  
                data-vv-as="reason"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      separationReason: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localSeparationReason: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) this.localSeparationReason = { ...this.separationReason }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.separationReasons().update(this.localSeparationReason.id, { reason: this.localSeparationReason.reason })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(error => {
                if (error.response.status === 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })      
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
